import { LoadableStatus } from '@aiwyn/shared';
import { CxpStaffMember, CxpTask } from '../models';

export interface CxpTasksStateModel {
  // Navigation IDs (synced from route-params service)
  selectedRequestId: number | null;

  // Core data — the mapped rows from `GET /cxp/tasks/list` (pre-joined by the
  // backend with serviceLine + clientName, so no client-side join remains).
  status: LoadableStatus;
  tasks: CxpTask[];

  // Support data — staff identities resolved for the sidebar (rows carry only
  // staffIds; the backend does not join staff detail).
  staff: CxpStaffMember[];

  // Every-page nav badge open-count, from the cheap `GET /cxp/tasks/count`.
  badgeOpenCount: number;
}

export const DEFAULT_CXP_TASKS_STATE: CxpTasksStateModel = {
  selectedRequestId: null,
  status: LoadableStatus.DEFAULT,
  tasks: [],
  staff: [],
  badgeOpenCount: 0,
};
